module.exports = __webpack_public_path__ + "static/img/3939_phase_function_Paper_Points.d030697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3939_phase_function_Paper_Points.png
// module id = iHdb
// module chunks = 0